module.exports = __webpack_public_path__ + "static/media/logo-핏펫@2x.bfd3d008.png";